<template>
  <!-- begin:: Footer -->
  <div
    class="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop"
    id="kt_footer"
  >
    <div
      class="kt-container"
      v-bind:class="{ 'kt-container--fluid': isFluid() }"
    >
      <div class="kt-footer__copyright">
        {{ currentYear }} &nbsp;&copy;&nbsp;Voxeus
      </div>
      <div class="kt-footer__menu">
        <a
          :href="piDomain + 'privacy'"
          class="kt-footer__menu-link kt-link"
          target="_blank"
          >Privacy</a
        >
        <a
          :href="piDomain + 'legal'"
          class="kt-footer__menu-link kt-link"
          target="_blank"
          >Legal</a
        >
        <a
          :href="piDomain + 'terms'"
          class="kt-footer__menu-link kt-link"
          target="_blank"
          >Terms</a
        >
      </div>
    </div>
  </div>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from "vuex";
import Config from "@/common/config";

export default {
  name: "KTFooter",
  data() {
    return {
      currentYear: new Date().getFullYear(),
      piDomain: Config.get("platform_listening")
    };
  },
  methods: {
    /**
     * Check if footer container is fluid
     * @returns {boolean}
     */
    isFluid() {
      return this.layoutConfig("footer.self.width") === "fluid";
    }
  },
  computed: {
    ...mapGetters(["layoutConfig"])
  }
};
</script>
